import React, { useEffect, useRef } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const features = [
  'Private, one-to-one consultations',
  'Premium international product houses',
  'Bridal & occasion concierge service',
  'Hygiene protocols of clinical standard',
]

export default function Experience() {
  const ref = useRef<HTMLElement>(null)
  const statsRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!ref.current) return

    const ctx = gsap.context(() => {
      gsap.fromTo(
        ref.current.querySelector('.experience__title'),
        { opacity: 0, y: 40 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: ref.current,
            start: 'top 80%',
            once: true,
          },
        }
      )

      gsap.fromTo(
        ref.current.querySelectorAll('.experience__feature'),
        { opacity: 0, x: -30 },
        {
          opacity: 1,
          x: 0,
          duration: 0.8,
          stagger: 0.15,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: ref.current,
            start: 'top 75%',
            once: true,
          },
        }
      )

      // Animate stats
      const statNums = statsRef.current?.querySelectorAll('.stat__number')
      if (statNums) {
        statNums.forEach((num) => {
          const target = parseInt(num.getAttribute('data-target') || '0', 10)
          gsap.fromTo(
            num,
            { innerText: 0 },
            {
              innerText: target,
              duration: 2,
              ease: 'power2.out',
              scrollTrigger: {
                trigger: statsRef.current,
                start: 'top 80%',
                once: true,
              },
              snap: { innerText: 1 },
            }
          )
        })
      }
    }, ref.current)

    return () => ctx.revert()
  }, [])

  return (
    <section ref={ref} className="experience">
      <div className="experience__inner">
        <div className="experience__content">
          <span className="experience__label">The Experience</span>
          <h2 className="experience__title">
            An Appointment, <em>Not a Visit</em>
          </h2>
          <p className="experience__text">
            From the first consultation to the final reveal, everything at Aure is
            unhurried and intentional. A quiet chair, an honest conversation, and
            hands that have practised their craft thousands of times.
          </p>
          <ul className="experience__features">
            {features.map((f, i) => (
              <li key={i} className="experience__feature">
                <span className="experience__check">✓</span>
                {f}
              </li>
            ))}
          </ul>
        </div>

        <div ref={statsRef} className="experience__stats">
          <div className="stat">
            <span className="stat__number" data-target="15">0</span>
            <span className="stat__label">Years of craft</span>
          </div>
          <div className="stat">
            <span className="stat__number" data-target="12">0</span>
            <span className="stat__label">Resident artists</span>
          </div>
          <div className="stat">
            <span className="stat__number" data-target="5000">0</span>
            <span className="stat__label">Guests groomed</span>
          </div>
        </div>
      </div>
    </section>
  )
}